import React from 'react';
import PropTypes from 'prop-types';

const PersonIcon = ({ color }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.466 27.27"
      width="25.47px"
      height="27.27px"
      role="img"
    >
      <title>Person Icon</title>
      <g transform="translate(-13.625 -11.226)">
        <circle
          className="a"
          cx="8.504"
          cy="8.504"
          r="8.504"
          transform="translate(17.854 11.226)"
        />
        <path
          className="a"
          d="M33.378,55.514a10.728,10.728,0,0,1-14.039,0,12.719,12.719,0,0,0-5.713,10.622H39.091A12.719,12.719,0,0,0,33.378,55.514Z"
          transform="translate(0 -27.641)"
        />
      </g>
    </svg>
  );
};

export default PersonIcon;

PersonIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
